const LoginPage = (props) => {
  return null;
};

export default LoginPage;
